// extracted by mini-css-extract-plugin
module.exports = {"documentsTable":"documentsTable__NNMoa","duplicatesTable":"duplicatesTable__w-DWO","message":"message__0aS6Z"};